import React,{ useState, useEffect } from "react";
import { Doughnut, Bar } from "react-chartjs-2";
import {
  Chart as ChartJS,
  ArcElement,
  CategoryScale,
  LinearScale,
  BarElement,
  Tooltip,
  Legend,
} from "chart.js";
 import {  Pie } from "react-chartjs-2";
import { getCombinedFirstProjectDashboardData, getCombinedSecondDashboardData, getTaskStatusbyProject, getTileDashboard } from "../../api/dashboard";
import { getAllProject } from "../../api/projectManagement";
import { useSelector } from "react-redux";
const projectColors = [
  "bg-blue-500",
  "bg-green-500",
  "bg-lime-500",
  "bg-orange-500",
  "bg-rose-500",
  "bg-slate-600",
];
ChartJS.register(ArcElement, CategoryScale, LinearScale, BarElement, Tooltip, Legend);

export default function Dashboard() {
  const user = useSelector((state) => state?.user) ;
  const [projects, setProjects] = useState([]);
  const [selectedProjectId, setSelectedProjectId] = useState("");
const [projectsFilterData, setProjectsFilterData] = useState([]);
  const [dashboardStats, setDashboardStats] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalRecords, setTotalRecords] = useState(0);
    const [selectedProjectData, setSelectedProjectData] = useState(null);
  useEffect(() => {
    const fetchProjectData = async () => {
      try {
        const { data } = await getCombinedSecondDashboardData(user.token);
        if (data?.status && Array.isArray(data?.taskTotal) && data.taskTotal.length > 0) {
          setSelectedProjectData(data.taskTotal);
        } else {
          setSelectedProjectData(null);
        }
      } catch (e) {
        setError(e?.message || "Failed to load project data");
        setSelectedProjectData(null);
      } finally {
        setLoading(false);
      }
    };
    fetchProjectData();
  }, [selectedProjectId, user?.token]);
  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      // setError(null);
      try {
        const { data } = await getTileDashboard(user.token);

          setDashboardStats(data);

        
      } catch (e) {
        // setError(e?.message || "Failed to load dashboard data");
      } finally {
      
      }
    };
    if (user?.token) fetchData();
  }, [user?.token]);
  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      setError(null);
      try {
        const offset = (currentPage - 1) * rowsPerPage;
        const params = {
          limit: rowsPerPage,
          offset,
          project_id: selectedProjectId,
        };
   
        const { data } = await getTaskStatusbyProject(user.token, params);
        if (data?.status && Array.isArray(data?.data)) {
          setProjectsFilterData(
            data.data.map((proj, i) => ({
              ...proj,
              color: projectColors[i % projectColors.length],
            }))
          );
          setTotalRecords(data?.total_count || 0);
        } else {
          setError("No dashboard data found");
        }
      } catch (e) {
        setError(e?.message || "Failed to load dashboard data");
      } finally {
        setLoading(false);
      }
    };
    if (user?.token) fetchData();
  }, [user?.token, rowsPerPage, currentPage, selectedProjectId]);
  // useEffect(() => {
  //   const getProjects = async () => {
  //     try {
  //       const { data } = await getAllProject(user.token, {});
  //       setProjects(data?.data?.projects || []);
  //     } catch (error) {
  //       console.error("Error fetching projects:", error);
  //     }
  //   };
  //   if (user?.token) getProjects();
  // }, [user?.token]);
  
  
  if (loading) {
    return (
      <div className="flex justify-center items-center h-96">
        <span className="text-gray-400">Loading dashboard...</span>
      </div>
    );
  }
  if (error) {
    return (
      <div className="flex justify-center items-center h-96">
        <span className="text-red-500">{error}</span>
      </div>
    );
  }



  const handleRowsPerPageChange = (e) => {
    setRowsPerPage(parseInt(e.target.value, 10));
    setCurrentPage(1); // Reset to the first page
  };

  const handlePageChange = (page) => {
    setCurrentPage(page);
  };

  return (
    
//     <div className="overflow-x-auto">
//       {/* Project Filter */}
 
//       <div className="grid grid-cols-4 gap-2 py-4">
//         {projectsFilterData.map((project) => (
//           <div
//             key={project.project_id}
//             className="flex flex-col  bg-white rounded-xl border border-gray-200 shadow hover:shadow-lg transition"
//           >
//             {/* Header */}
//             <div className={`${project.color} text-white text-center p-2 rounded-t-xl`}>
//               <div className="font-semibold">{project.project_name}</div>
//               <div className="text-xs">Status: {project.project_status ?? "N/A"}</div>
//             </div>

//             {/* Task Statuses Doughnut */}
//             <div className="flex justify-center py-3">
//               {/* Robust mapping for various API task status keys */}
//               {(() => {
//                 const statusMap= {};
//                 if (project.task_status_counts) {
//                   for (const [k, v] of Object.entries(project.task_status_counts)) {
//                     const key = k.toLowerCase().replace(/[-_ ]/g, "");
//                     if (["pending"].includes(key)) statusMap["Pending"] = v ;
//                     else if (["inprogress", "in-progress", "in_progress"].includes(key)) statusMap["In Progress"] = v ;
//                     else if (["completed"].includes(key)) statusMap["Completed"] = v ;
//                     // Optionally handle "Delayed", "total", etc. if needed
//                   }
//                 }
//                 // Ensure all expected keys exist
//                 statusMap["Pending"] = statusMap["Pending"] || 0;
//                 statusMap["In Progress"] = statusMap["In Progress"] || 0;
//                 statusMap["Completed"] = statusMap["Completed"] || 0;
//                 const allZero = !statusMap["Pending"] && !statusMap["In Progress"] && !statusMap["Completed"];
//                 return (
//                   <Doughnut
//                     data={{
//                       labels: ["Pending", "In Progress", "Completed"],
//                       datasets: [
//                         {
//                           data: allZero ? [1, 0, 0] : [statusMap["Pending"], statusMap["In Progress"], statusMap["Completed"]],
//                           backgroundColor: ["#f87171", "#fbbf24", "#34d399"],
//                           borderWidth: 0,
//                         },
//                       ],
//                     }}
//                     options={{
//                       responsive: false,
//                       maintainAspectRatio: false,
//                       animation: false,
//                       hover: { mode: "index" },
//                       plugins: {
//                         legend: {
//                           display: true,
//                           position: "bottom",
//                           labels: {
//                             boxWidth: 12,
//                             font: { size: 10 },
//                           },
//                         },
//                       },
//                       cutout: "60%",
//                     }}
//                     className="w-24 h-24 opacity-90"
//                   />
//                 );
//               })()}

//             </div>

//             {/* Planned vs Actual
//             <div className="px-4">
//               <p className="text-xs font-medium text-gray-500 mb-1">Planned vs Actual Hours</p>
//               <Bar
//                 data={{
//                   labels: ["Planned", "Actual"],
//                   datasets: [
//                     {
//                       label: "Hours",
//                       data: [Number(project.hours_budgeted), Number(project.hours_actual)],
//                       backgroundColor: ["#3B82F6", "#10B981"],
//                       borderRadius: 4,
//                     },
//                   ],
//                 }}
//                 options={{
//                   responsive: true,
//                   plugins: { legend: { display: false } },
//                   scales: {
//                     y: { beginAtZero: true },
//                   },
//                 }}
//                 className="!h-24"
//               />
//             </div> */}

//             {/* Task Priorities */}
//             <div className="p-4 flex flex-col space-y-1">
//               <p className="text-xs font-medium text-gray-500 mb-1">Task Priorities</p>
//               {["High", "Medium", "Low"].map((level) => (
//                 <div key={level} className="flex items-center space-x-1">
//                   <div className="w-12 text-xs">{level}</div>
//                   <div className="flex-1 h-1 bg-gray-200 rounded-full">
//                     <div
//                       className={`h-1 rounded-full ${level === "High"
//                           ? "bg-red-500"
//                           : level === "Medium"
//                             ? "bg-yellow-400"
//                             : "bg-green-400"
//                         }`}
//                       style={{
//                         width: `${Number(project.priorities?.[level]) * 33}%`,
//                       }}
//                     />
//                   </div>
//                   <div className="text-xs w-4 text-right">{project.priorities?.[level]}</div>
//                 </div>
//               ))}
//             </div>
//           </div>
//         ))}
        
//       </div>
//           {dashboardStats && (
//       <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 mt-[10px]">
//         {[
//           { label: "Total Projects", value: dashboardStats?.ProjectCount },
//           { label: "Delayed Projects", value: dashboardStats?.DelayedProjectCount },
//           { label: "Total Tasks", value: dashboardStats?.taskTotal },
//         ].map((stat, i) => (
//           <div
//             key={i}
//             className="rounded-lg bg-gradient-to-r from-sky-400 to-sky-600 p-4 text-white shadow flex flex-col items-center"
//           >
//             <div className="text-xs">{stat.label}</div>
//             <div className="text-2xl font-bold">{stat.value}</div>
//           </div>
//         ))}
//       </div>
//     )}
//            {/* Tasks by Resource */}
//            {selectedProjectData?.length > 0 && (
//               <div className="space-y-2 mt-[20px]">
//                 <h3 className="text-sm font-medium text-gray-700 text-center">Tasks by Resource</h3>
//                 <div className="h-64">
//                   <Pie
//                     data={{
//                       labels: selectedProjectData.map((r) => r.emp_name),
//                       datasets: [
//                         {
//                           data: selectedProjectData.map((r) => r.count),
//                           backgroundColor: [
//     '#FF6B6B', '#6BCB77', '#4D96FF',
//     '#FFD93D', '#C34A36', '#9D4EDD',
//     '#00C9A7', '#F95738', '#3EC1D3',
//     '#FF9F1C', '#8AC926', '#1982C4'
//   ],
//                         },
//                       ],
//                     }}
//                     options={{
//                         plugins: {
//                           legend: {
//                             position: "right",
//                             align: "center", // vertical center alignment
//                             labels: {
//                               boxWidth: 12,
//                               padding: 16,
//                               font: { size: 12 },
//                             },
//                           },
//                         },
//                         responsive: true,
//                         maintainAspectRatio: false,
//                       }}
                      
//                   />
//                 </div>
//               </div>
//             )}

      
// {/* Floating Pagination Buttons */}
// <div>
//   {/* Prev Button */}
//   <button
//     onClick={() => handlePageChange(Math.max(currentPage - 1, 1))}
//     disabled={currentPage === 1}
//     className="fixed bottom-6 left-6 flex items-center gap-2 px-4 py-2 rounded-full shadow-lg bg-white text-gray-700 border border-gray-300 hover:bg-gray-100 disabled:opacity-50"
//   >
//     <svg
//       xmlns="http://www.w3.org/2000/svg"
//       className="h-4 w-4"
//       fill="none"
//       viewBox="0 0 24 24"
//       stroke="currentColor"
//     >
//       <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 19l-7-7 7-7" />
//     </svg>
//     Prev
//   </button>

//   {/* Next Button */}
//   <button
//     onClick={() =>
//       handlePageChange(
//         currentPage < Math.ceil(totalRecords / rowsPerPage)
//           ? currentPage + 1
//           : currentPage
//       )
//     }
//     disabled={currentPage === Math.ceil(totalRecords / rowsPerPage)}
//     className="fixed bottom-6 right-6 flex items-center gap-2 px-4 py-2 rounded-full shadow-lg bg-white text-gray-700 border border-gray-300 hover:bg-gray-100 disabled:opacity-50"
//   >
//     Next
//     <svg
//       xmlns="http://www.w3.org/2000/svg"
//       className="h-4 w-4"
//       fill="none"
//       viewBox="0 0 24 24"
//       stroke="currentColor"
//     >
//       <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
//     </svg>
//   </button>

//   {/* Current Page Indicator */}
//   <div className="fixed bottom-6 left-1/2 -translate-x-1/2 bg-white px-3 py-1 rounded shadow text-sm text-gray-600 border border-gray-300">
//     Page {currentPage} of {Math.max(1, Math.ceil(totalRecords / rowsPerPage))}
//   </div>
// </div>


//     </div>
  <div className="overflow-x-auto px-4 pb-20">
      {/* Project Cards */}
      <div className="py-6 px-4 sm:px-6 lg:px-8">
  <h1 className="text-2xl font-bold text-gray-800">Project Dashboard</h1>
  <p className="text-sm text-gray-500 mt-1">Overview of projects, tasks, and resource allocations</p>
</div>
      <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4 py-4">
        {projectsFilterData.map((project) => {
          const statusMap = { Pending: 0, "In Progress": 0, Completed: 0 };
          if (project.task_status_counts) {
            for (const [k, v] of Object.entries(project.task_status_counts)) {
              const key = k.toLowerCase().replace(/[-_ ]/g, "");
              if (["pending"].includes(key)) statusMap["Pending"] = v;
              else if (["inprogress", "in-progress", "in_progress"].includes(key)) statusMap["In Progress"] = v;
              else if (["completed"].includes(key)) statusMap["Completed"] = v;
            }
          }
          const allZero = Object.values(statusMap).every((val) => val === 0);

          return (
            <div
              key={project.project_id}
              className="bg-white rounded-xl border border-gray-200 shadow-md hover:shadow-lg transition overflow-hidden"
            >
              <div className={`${project.color} text-white p-3 text-center font-semibold text-sm`}> 
                <div>{project.project_name}</div>
                <div className="text-xs">Status: {project.project_status ?? "N/A"}</div>
              </div>

              <div className="flex justify-center py-4">
                <Doughnut
                  data={{
                    labels: ["Pending", "In Progress", "Completed"],
                    datasets: [
                      {
                        data: allZero ? [1, 0, 0] : [statusMap["Pending"], statusMap["In Progress"], statusMap["Completed"]],
                        backgroundColor: ["#f87171", "#fbbf24", "#34d399"],
                        borderWidth: 0,
                      },
                    ],
                  }}
                  options={{
                    responsive: false,
                    maintainAspectRatio: false,
                    animation: false,
                    plugins: {
                      legend: {
                        display: true,
                        position: "bottom",
                        labels: { boxWidth: 10, font: { size: 10 } },
                      },
                    },
                    cutout: "65%",
                  }}
                  className="w-24 h-24"
                />
              </div>

              <div className="px-4 pb-4">
                <p className="text-xs font-medium text-gray-500 mb-1">Task Priorities</p>
                {["High", "Medium", "Low"].map((level) => (
                  <div key={level} className="flex items-center gap-2 text-xs">
                    <div className="w-12">{level}</div>
                    <div className="flex-1 h-1 bg-gray-200 rounded-full">
                      <div
                        className={`h-1 rounded-full ${
                          level === "High" ? "bg-red-500" : level === "Medium" ? "bg-yellow-400" : "bg-green-400"
                        }`}
                        style={{
                          width: `${Number(project.priorities?.[level]) * 33}%`,
                        }}
                      />
                    </div>
                    <div className="w-4 text-right">{project.priorities?.[level]}</div>
                  </div>
                ))}
              </div>
            </div>
          );
        })}
      </div>

      {/* Dashboard Stats */}
      {dashboardStats && (
        <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 mt-6">
          {[
            { label: "Total Projects", value: dashboardStats?.ProjectCount },
            { label: "Delayed Projects", value: dashboardStats?.DelayedProjectCount },
            { label: "Total Tasks", value: dashboardStats?.taskTotal },
          ].map((stat, i) => (
            <div
              key={i}
              className="rounded-xl bg-gradient-to-r from-sky-400 to-sky-600 p-4 text-white shadow text-center"
            >
              <div className="text-sm">{stat.label}</div>
              <div className="text-2xl font-bold">{stat.value}</div>
            </div>
          ))}
        </div>
      )}

      {/* Tasks by Resource */}
      {selectedProjectData?.length > 0 && (
        <div className="mt-10">
          <h3 className="text-center text-sm font-medium text-gray-700 mb-4">Tasks by Resource</h3>
          <div className="h-64">
            <Pie
              data={{
                labels: selectedProjectData.map((r) => r.emp_name),
                datasets: [
                  {
                    data: selectedProjectData.map((r) => r.count),
                    backgroundColor: [
                      '#FF6B6B', '#6BCB77', '#4D96FF', '#FFD93D', '#C34A36', '#9D4EDD',
                      '#00C9A7', '#F95738', '#3EC1D3', '#FF9F1C', '#8AC926', '#1982C4'
                    ],
                  },
                ],
              }}
              options={{
                plugins: {
                  legend: {
                    position: "right",
                    labels: { boxWidth: 12, padding: 16, font: { size: 12 } },
                  },
                },
                responsive: true,
                maintainAspectRatio: false,
              }}
            />
          </div>
        </div>
      )}

      {/* Floating Pagination Buttons */}
      <div>
        <button
          onClick={() => handlePageChange(Math.max(currentPage - 1, 1))}
          disabled={currentPage === 1}
          className="fixed bottom-6 left-6 flex items-center gap-2 px-4 py-2 rounded-full shadow-lg bg-white text-gray-700 border border-gray-300 hover:bg-gray-100 disabled:opacity-50"
        >
          <svg className="h-4 w-4" viewBox="0 0 24 24" stroke="currentColor" fill="none">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 19l-7-7 7-7" />
          </svg>
          Prev
        </button>

        <button
          onClick={() => handlePageChange(
            currentPage < Math.ceil(totalRecords / rowsPerPage) ? currentPage + 1 : currentPage
          )}
          disabled={currentPage === Math.ceil(totalRecords / rowsPerPage)}
          className="fixed bottom-6 right-6 flex items-center gap-2 px-4 py-2 rounded-full shadow-lg bg-white text-gray-700 border border-gray-300 hover:bg-gray-100 disabled:opacity-50"
        >
          Next
          <svg className="h-4 w-4" viewBox="0 0 24 24" stroke="currentColor" fill="none">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
          </svg>
        </button>

        <div className="fixed bottom-6 left-1/2 -translate-x-1/2 bg-white px-4 py-2 rounded-full shadow text-sm text-gray-600 border border-gray-300">
          Page {currentPage} of {Math.max(1, Math.ceil(totalRecords / rowsPerPage))}
        </div>
      </div>
    </div>
  );
}

